import React, { useMemo } from "react";
import DropdownMenu from "../../../components/controls/DropdownMenu";

const getRoleLabel = (role) => role.description || role.name || "";
const getRoleCode = (role) => role.code || role.name || "";

const buildRoleItems = (roles) =>
  (roles || []).map((role, index) => ({
    key: role.id ?? `${getRoleCode(role)}-${index}`,
    value: role.id,
    label: `${getRoleCode(role)} - ${getRoleLabel(role)}`.trim(),
  }));

const buildTitle = (availableRoles, values, label, placeholder) => {
  const selected = (availableRoles || []).filter((r) =>
    (values || []).includes(r.id)
  );
  if (!selected.length) return placeholder;
  return selected
    .map((r) => getRoleLabel(r))
    .filter(Boolean)
    .join(", ");
};

export default function UserRoleSelection({
  values = [],
  onChange,
  availableRoles = [],
  label = "Rôles",
  placeholder = "Sélectionner des rôles",
  withSearch = true,
}) {
  const items = useMemo(() => buildRoleItems(availableRoles), [availableRoles]);

  const title = useMemo(
    () => buildTitle(availableRoles, values, label, placeholder),
    [availableRoles, values, label, placeholder]
  );

  return (
    <div className="w-full">
      <DropdownMenu
        title={title}
        isDropdown
        withSearch={withSearch}
        searchPlaceholder="Rechercher un rôle..."
        multiselect
        items={items}
        selectedValues={values}
        onSelectionChange={onChange}
      />
    </div>
  );
}
